import p from "./ghl-ui.es1589.js";
import f from "./ghl-ui.es1590.js";
import o from "./ghl-ui.es1586.js";
import u from "./ghl-ui.es1587.js";
import c from "./ghl-ui.es1588.js";
import n from "./ghl-ui.es1591.js";
import { Parser as l } from "./ghl-ui.es1670.js";
import { parseAnyDigitsSigned as h } from "./ghl-ui.es1671.js";
var C = /* @__PURE__ */ function(m) {
  u(t, m);
  var s = c(t);
  function t() {
    var r;
    p(this, t);
    for (var i = arguments.length, a = new Array(i), e = 0; e < i; e++)
      a[e] = arguments[e];
    return r = s.call.apply(s, [this].concat(a)), n(o(r), "priority", 40), n(o(r), "incompatibleTokens", "*"), r;
  }
  return f(t, [{
    key: "parse",
    value: function(i) {
      return h(i);
    }
  }, {
    key: "set",
    value: function(i, a, e) {
      return [new Date(e * 1e3), {
        timestampIsSet: !0
      }];
    }
  }]), t;
}(l);
export {
  C as TimestampSecondsParser
};
